import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, " Инструкции по работе с порталом ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_video = _resolveComponent("ui-video")!
  const _component_ui_modal_with_content = _resolveComponent("ui-modal-with-content")!

  return (_openBlock(), _createBlock(_component_ui_modal_with_content, {
    target: "modal",
    "has-custom-container-style": "",
    "custom-container-style": {
      borderRadius: 'var(--border-radius-xlarge)',
      boxShadow: 'var(--modal-container-shadow)',
      backgroundColor: 'var(--color-background)',
      padding: '0 32px 24px',
    },
    "overlay-color": "dark-blue",
    width: 944,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ui_video, {
        width: "880",
        height: "500",
        "img-frame-url": $options.imgFrame,
        "video-url": "https://www.youtube.com/embed/-fVVrENQSHg"
      }, null, 8, ["img-frame-url"])
    ]),
    _: 1
  }, 8, ["custom-container-style"]))
}